
<form (ngSubmit)="onSubmit(AddPartnerForm)" #AddPartnerForm="ngForm">
  <p-dialog  [(visible)]="displayAddDialog" 
    [modal]="true"
    [positionTop]="50"
    [maximizable]="true"
    [contentStyle]="{'min-width':'700px'}"
    (onHide)="dialogClose(AddPartnerForm)" 
    (onShow)="dialogOpen()">
   
    <p-header>
        <b>Add Partner</b>
    </p-header>
    
    <div class="ui-grid ui-grid-responsive formcontainer dialog-content"> 
      <div class="formgroup">
        <div class="ui-grid-row">
          <div class="ui-grid-col-12">
            <label for="partnertype">Partner Type <span class="custom-required">*</span></label>
          </div>
        </div>
        <div class="ui-grid-row">
            <div class="ui-grid-col-12">
              <p-dropdown [options]="partnerTypes" 
                [(ngModel)]="partnerTypeSelected" 
                optionLabel="Description" 
                placeholder="{{partnerTypes ? 'Select One' : 'Loading..'}}"
                autoDisplayFirst="false"
                required="true"
                [autoWidth]="false"
                name="PartnerType"
                [style]="{'width':'250px'}"
                #PartnerType="ngModel"
                (onChange)="partnerTypechange()"
                required = "true"
                >
              </p-dropdown>
            </div>
        </div>
        <span *ngIf="PartnerType.invalid && PartnerType.touched" class="custom-error">Partner Type is required</span>
      </div>
      <div class="formgroup">
        <div class="ui-grid-row">
            <div class="ui-grid-col-12">
              <label for="Partner">Partner <span class="custom-required">*</span></label>
            </div>
        </div>
        <div class="ui-grid-row">
            <div class="ui-grid-col-12 vert-center">            
                <p-autoComplete [(ngModel)]="partnerSelected" 
                  [suggestions]="partners" 
                  (completeMethod)="partnerSearch($event)" 
                  field="ItemCompanyName" 
                  name="Partner"
                  size="50"
                  [style]="{'height':'26px'}"
                  placeholder="{{partnerListLoading ? 'Loading..' : 'Search'}}" 
                  [dropdown]="true"
                  [dropdownMode]="'current'"
                  [disabled]="!PartnerType.valid"
                  (onSelect)="partnerChange()"
                  #Partner="ngModel">
                </p-autoComplete>
                <i class="pi pi-info-circle" style="font-size:24px" pTooltip="The Partner (Company) is a way to filter and group the Assets and Users together.  In future steps, you will add users to this Partnership.  Every user is added as part of a Partnership and they have a relationship.  Admin users at the Partner can see all other users that share the same Partner name and can manage their access."></i>
            </div>
        </div>
        <span *ngIf="!partnerSelected && Partner.touched" class="custom-error">Partner is required</span>
        <span *ngIf="partnerSelected && !partnerListLoading && !partnerSelected.ItemCompanyName && Partner.touched" class="custom-error">No Matching records found. Please try again</span>
      </div>
      <div class="formgroup">
        <div class="ui-grid-row">
          <div class="ui-grid-col-6">
            <div class="ui-inputgroup">
              <span class="ui-inputgroup-addon"><i class="pi pi-search"></i></span>
              <input type="text" pInputText placeholder="Search available Asset IDs" size="40" [disabled]="!partnerSelected" [(ngModel)]="searchInput" name="searchInput" id="searchInput" (keyup)="searchTextInput($event.target.value)">
              <i class="pi pi-info-circle" style="font-size:24px" pTooltip="Enter search criteria to filter the list of available Asset IDs to assign to the Partner selected"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="formgroup">
        <div class="ui-grid-row">
            <div class="ui-grid-col-12">
              <label for="partner">Master Asset Group <span class="custom-required">*</span></label>
            </div>
        </div>
        <div class="ui-grid-row">
            <div class="ui-grid-col-12">
              <app-picklist-asset-group [availableGroup] = availableGroup [selectedGroup]="selectedGroup" [disabled]="!partnerSelected" [loading]= "assetGroupLoading" [showSourceFilter]="false" [showTargetFilter]="true"></app-picklist-asset-group>
            </div>
        </div>
        <span class="custom-error" *ngIf="assetIdCount > 200">Showing first 200 results. Refine Search to see full list of Available Asset IDs</span>
        <span *ngIf="Partner.valid && partnerSelected && selectedGroup?.length <= 0" class="custom-error">Please select at least one Master Group</span>
      </div>

      <div class="formgroup">
          <div class="ui-grid-row">
              <div class="ui-grid-col-12">
                <label for="Privileges">Master Admin Privileges<span class="custom-required">*</span></label>
              </div>
          </div>
          <div class="ui-grid-row">
            <app-privilege-dropdown
              [privilegeGroup]="relationshipTypePrivileges" 
              [preSelectedPrivilege]="relationshipTypePrivileges"
              [maxSelectedLabels]="1"
              [group]=true
              defaultLabel="Select Privilege" 
              filterPlaceHolder=""
              (onChange)="privilegeChange($event)">
            </app-privilege-dropdown>
            <i class="pi pi-info-circle" style="font-size:24px" pTooltip="Privileges control what each user is able to see and do in the EQ Connect Portal. This Master set creates an Admin privilege group which the Primary Contact will be part of.  If given the Add/Edit Partner Users privilege, the Admins can assign all or a subset of the Master set to each additional user."></i>
            <span [ngClass]="{'check-circle-gray': selectedItemsNow?.length <=0,
                              'check-circle-green': selectedItemsNow?.length > 0}">
              <i class="pi pi-check-circle"></i>
            </span>
          </div>
          <span *ngIf="PartnerType.valid && selectedItemsNow?.length <=0" class="custom-error">Master Admin Privileges are required</span>
      </div>

      <h3>Create Primary Partner User</h3>
      
      <div class="formgroup">
        <div class="ui-grid-row">
          <div class="ui-grid-col-12">
            <label for="Email">Email Address <span class="custom-required">*</span></label>
          </div>
        </div>
        <div class="ui-grid-row">
          <div class="ui-grid-col-12">
            <input type="text" pInputText name="Email" id="Email" size="35" [(ngModel)]="person.Email" #email="ngModel" required customEmail>
          </div>
        </div>
        <span *ngIf="email.errors?.required && email.touched" class="custom-error">Email is required</span>
        <span *ngIf="(email.errors?.email || email.errors?.invalidEmail) && email.touched" class="custom-error">Email is invalid.</span>
      </div>
      <div class="formgroup">
        <div class="ui-grid-row">
          <div class="ui-grid-col-12">
            <label for="UniqueKey">Unique Key:</label>
          </div>
        </div>
        <div class="ui-grid-row">
            <div class="ui-grid-col-12">
              <input type="text" pInputText name="uniqueKey" id="uniqueKey" size="35" [(ngModel)]="partnerUser.UniqueKey">
            </div>
        </div>
      </div>
    </div>

    <p-footer>
      <button pButton type="button" label="Cancel" class="ui-button-secondary" (click)="cancelDialog()"></button>
      <button pButton type="submit" label="{{processing ? 'Processing' : 'Create Partner'}}" [disabled]="!AddPartnerForm.form.valid || selectedGroup?.length <= 0 || processing || !partnerSelected.ItemCompanyName || selectedItemsNow?.length <=0"></button>
    </p-footer>
  </p-dialog>
</form>
